import * as React from "react";
import { observer } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { Opportunity } from "../../../models/opportunity";
import { ILocalization } from "../../../models/localization";
import { sort } from "../../../utils/data";
import List, { ListItem, ListItemText } from "material-ui/List";
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card';
import { SavedOpportunityState } from "../../../models/enums";
import { Row, Col, Grid } from "react-flexbox-grid";
import { SavedOpportunity } from "../../../models/profile";
import { OpLabels } from "../../widgets/opLabels";
import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withMobileDialog,
} from 'material-ui/Dialog';
import * as s from "./savedOp.css";

@observer
class DeleteSavedOpDlg extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (!this.props.store.profileStore.deleteSavedOp) {
      return null;
    }
    const os: Opportunity = this.props.store.profileStore.deleteSavedOp;
    const msg: string = `${this.props.store.localization.fields.delRsrcDlg.question1} ${os.name} ${this.props.store.localization.fields.opportunity.fromSaved}`;
 
    return (<Dialog
      fullScreen={false}
      open={true}
      onClose={this.props.store.profileStore.clearDeleteSavedOp}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">{this.props.store.localization.fields.delRsrcDlg.title}</DialogTitle>
      <DialogContent>
        {msg}
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.store.profileStore.clearDeleteSavedOp} color="secondary">{this.props.store.localization.fields.cancel}</Button>
        <Button onClick={() => this.props.store.profileStore.unwatchOpportunity(os)} color="secondary">{this.props.store.localization.fields.delete}</Button>
      </DialogActions>
    </Dialog>);
  }
}

@observer
export default class SavedOpCard extends React.Component<{ store: SeekerStore, op: Opportunity }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    if (!this.props.op) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    const os: Opportunity = this.props.op;   
    const savedOp: SavedOpportunity = this.props.store.profileStore.getSavedOpportunity(os.idHash);
    const imgUrl: string = "../image/" + os.imageId;
    const hasApplied: boolean = (savedOp.status & SavedOpportunityState.Applied) > 0; 

    return (<Col xs={12} sm={6} md={4} lg={4} xl={3} key={"ops-" + os.idHash} >
          <div>
            <div className={s.outerBox}  >
          <img src={imgUrl} width="100%" height="auto" onClick={() => hashHistory.push(`opportunities/${os.idHash}`)}  />
              <div className={s.innerBox}></div>
              <div className={s.onTop} onClick={() => hashHistory.push(`opportunities/${os.idHash}`)}  >
                <p className={s.locationText}>{os.location}</p>
                <p className={s.locationText}>{os.postedBy}</p>
              </div>
              <img src={local.icons.xSign} className={s.closeIcon} onClick={() => this.props.store.profileStore.setDeleteSavedOp(os)} />
              <OpLabels isNew={os.flagAsNew} allowApply={os.allowApply} applied={hasApplied} score={savedOp.fit} store={this.props.store} op={os} />
            </div>
            <div>
          <Row>
            <Col xs={12}><p onClick={() => hashHistory.push(`opportunities/${os.idHash}`)} className={s.summaryHeading}>{os.name}</p></Col>         
          </Row>
        </div>
          </div>
          <DeleteSavedOpDlg store={this.props.store} />
    </Col>);
  }
}



// WEBPACK FOOTER //
// ./src/components/opportunity/savedOpSummary/index.tsx